import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";

const CreateWards = () => {
  return (
    <Create
      title="Създаване на болнично отделение"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateWards;
